import { ValidationResult } from '../../../validation/validation-result';
import { TriggerPayload } from '../trigger-payload';
import { SuccessFeeInformationValidation } from './success-fee-information-validation';
import { TriggerPayloadValidation } from './trigger-payload-validation';

export class EnrolmentConfirmedTriggerPayloadValidation extends TriggerPayloadValidation {
	public validateInExistingResult(payload: TriggerPayload, result: ValidationResult): ValidationResult {
		new SuccessFeeInformationValidation().validateInExistingResult(payload, result);

		return result;
	}
}
